import { SxProps } from "@mui/material";

export const sxSubtitle: SxProps = {
  fontSize: 16,
	fontFamily: 'UnimedSans-Bold',
  color: '#383838',
  textAlign: 'left'
}

export const sxSearchTitle: SxProps = {
	fontFamily: 'Unimed-Sans',
	fontWeight: 600,
	fontSize: '16px', 
	lineHeight: '24px',
	color: '#383838',
}

export const sxTextField: SxProps = {
	width: '200px',
	input: {
		fontFamily: 'Unimed-Sans', 
		color: '#383838', 
		fontSize: '14px', 
	},
	'@media (max-width: 720px)': {
		width: '100%'
	}
}

export const sxButtonConsultar: SxProps = {
	borderRadius: '80px',
	height: '44px',
	padding: '24px 32px',
	'@media (max-width: 720px)': {
			width: 'stretch'
	}
}